import { Link } from "../../../util/router";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { plans } from "../../../components/PricingSectionCommon"

export default function SbPackages() {
  const sbm_plan = plans.find(p => p.id === "sbm")
  const sby_plan = plans.find(p => p.id === "sby")

  return (
    <div className="bg-white py-12 sm:py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Single CTA - billing selection happens on checkout page */}
        <div className="bg-green-700 rounded-2xl p-8 mb-12">
          <h2 className="text-3xl font-bold text-white text-center mb-4">
            Ready to Transform Your Life Insurance Sales?
          </h2>
          <p className="text-green-100 text-center mb-6 text-lg">
            Get started today with our risk-free guarantee.
          </p>

          <div className="bg-white rounded-xl p-6 max-w-2xl mx-auto">
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">What's Included</h3>
            <div className="grid sm:grid-cols-2 gap-3 mb-6">
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">10 team seats included</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">Unlimited video sends</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">Team analytics dashboard</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">Free training webinars</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">4 language options</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircleIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-700 text-sm">8-step guided script</span>
              </div>
            </div>

            <div className="text-center">
              <p className="text-gray-600 text-sm mb-4">Choose monthly or annual billing on the next page</p>
              <Link
                to="/checkout?product=sb"
                className="inline-block w-full sm:w-auto bg-green-600 text-white font-bold py-3 px-10 rounded-lg text-lg hover:bg-green-700 transition-colors"
              >
                Get Started Now
              </Link>
            </div>
          </div>

          <p className="text-center text-green-100 mt-6 text-sm">
            100% Money-Back Guarantee within 3 days. No questions asked.
          </p>
        </div>
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
          <p className="text-base/7 font-semibold text-green-700">Stairs and Buckets Package</p>
          <h1 className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Pricing and Features
          </h1>
          <div className="mt-10 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Pricing</h2>
              <p className="mt-4">
                <strong>Monthly Plan:</strong> ${sbm_plan.price} per month<br />
                <strong>Annual Plan:</strong> ${sby_plan.price} per year
              </p>
              <h2 className="mt-8 text-2xl font-bold tracking-tight text-green-800">Core Offer and Features</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li>
                  <strong>Key Tool:</strong> The Stairs and Buckets Video License (4.5 minutes long), a concise,
                  effective educational video that simplifies the life insurance conversation for clients.
                </li>
                <li>
                  <strong>Accessibility:</strong> Available in English, Spanish, Cantonese, and Mandarin to reach
                  diverse audiences.
                </li>
                <li>
                  <strong>Ease of Use:</strong> Designed to resonate with a wide range of customers, from teenagers to
                  highly educated professionals like engineers or doctors.
                </li>
              </ul>
            </div>
            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Key Benefits</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li>
                  <strong>Empowers Teams:</strong> Helps agents train their team members, allowing them to take on a
                  larger share of the sales effort and reduce reliance on the agent.
                </li>
                <li>
                  <strong>Increased Revenue:</strong> Agents can increase their sales by $100,000 annually by
                  consistently using this process.
                </li>
                <li>
                  <strong>Risk-Free:</strong> Includes a 100% Money-Back Guarantee if canceled within 3 days.
                </li>
                <li>
                  <strong>Affordable:</strong> Priced to be accessible for new agents and team members, with a return
                  on investment achievable with just one sale per month.
                </li>
              </ul>

              <h2 className="mt-8 text-2xl font-bold tracking-tight text-green-800">Package Includes</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li>
                  <strong>Stairs and Buckets Video License:</strong> Unlimited views and usage.
                </li>
                <li>
                  <strong>Training Webinar:</strong> A one-hour session teaching agents how to have effective client
                  conversations.
                </li>
                <li>
                  <strong>Eight-Step Guide:</strong> A step-by-step word script designed for quick onboarding and
                  implementation.
                </li>
                <li>
                  <strong>Online Platform Access:</strong> A centralized application to access the tool, analytics, and
                  accompanying training materials.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none my-8">
          <p className="text-base/7 font-semibold text-green-700">Stairs and Buckets Package</p>
          <h1 className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Detailed Features
          </h1>
          <div className="mt-10 grid max-w-xl grid-cols-1 gap-8 text-base/7 text-gray-700 lg:max-w-none lg:grid-cols-2">
            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Detailed Features</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li>
                  <strong>Eight-Step Guide:</strong> A simple, effective script that ensures quick ramp-up for agents, making it easy to adopt and implement the Stairs and Buckets process right away.
                </li>
                <li>
                  <strong>Team Functionality and Tracking:</strong>
                  <ul className="mt-2 ml-4 list-disc space-y-2">
                    <li>Agents can add team members, granting each their own login.</li>
                    <li>Team Training Metrics: Track how much each team member has trained and how frequently they use the sales process.</li>
                    <li>Accountability: Provides agents with critical data to ensure team members are engaged and utilizing the tools effectively.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="border border-green-700 rounded-lg p-6 shadow-lg">
              <h2 className="text-2xl font-bold tracking-tight text-green-800">Ease of Use and Mastery</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li>
                  <strong>Quick Start:</strong> Requires only a couple of hours of training to implement.
                </li>
                <li>
                  <strong>Long-Term Mastery:</strong> Encourages prolonged, repeated use to make the process second nature.
                </li>
                <li>
                  <strong>Perfect for Novices:</strong> Takes new or inexperienced salespeople and equips them with a reliable process for selling higher premium life insurance policies.
                </li>
              </ul>

              <h2 className="mt-8 text-2xl font-bold tracking-tight text-green-800">Unique Selling Proposition</h2>
              <ul className="mt-4 space-y-4 text-start">
                <li>
                  <strong>Plug-and-Play Tools:</strong> Designed for immediate use, reducing the need for extensive training or customization.
                </li>
                <li>
                  <strong>Simplified Training:</strong> Focuses on delivering a ready-to-use tool rather than complex systems agents must learn and implement themselves.
                </li>
                <li>
                  <strong>Efficiency:</strong> Minimizes time spent learning and mastering the content, allowing agents and their teams to start making sales right away.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
